import React from 'react'

function Footer() {
    return (
        <footer>&#169; 2022 #VANLIFE</footer>
    )
}

export default Footer
